<div
  [ngStyle]="getContainerStyles()"
  class="module-tool-wrapper"
  #moduleContainerRef
></div>
